import { render, staticRenderFns } from "./ReportesProyeccionTamtoAyer.vue?vue&type=template&id=06e9c6b4&scoped=true&"
import script from "./ReportesProyeccionTamtoAyer.vue?vue&type=script&lang=js&"
export * from "./ReportesProyeccionTamtoAyer.vue?vue&type=script&lang=js&"
import style0 from "./ReportesProyeccionTamtoAyer.vue?vue&type=style&index=0&id=06e9c6b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e9c6b4",
  null
  
)

export default component.exports